import localforage from 'localforage'

import dayjs from 'dayjs'
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)

const namespace = `${process.env.PACKAGE_NAME || 'app'}`

export const subscriptions = {
    namespaced: true,
    state: {
        paymentStatus: 'idle',
        activeSubscription: {},
        tempSubscription: {},
        tempSubscriptionPackage: {},
        boundles: [],
        trialDays: null
    },
    mutations: {
        SET_ACTIVE_SUBSCRIPTION(state, payload) {
            state.activeSubscription = {
                name: payload.name,
                price: payload.price,
                activeFrom: payload.active_from,
                activeTo: payload.active_to
            }
        },
        SET_TEMP_SUBSCRIPTION(state, payload) {
            state.tempSubscription = payload
        },
        SET_TEMP_SUBSCRIPTION_PACKAGE(state, payload) {
            state.tempSubscriptionPackage = payload
        },
        SET_TRIAL_DAYS(state, payload) {
            state.trialDays = payload
        },
        CHANGE_PAYMENT_STATUS(state, payload) {
            state.paymentStatus = payload
        },
        SET_SUBSCRIPTION_BOUNDLES(state, payload) {
            state.boundles = payload
        }
    },
    actions: {
        setTempSubscription({ commit }, payload) {
            commit('SET_TEMP_SUBSCRIPTION', payload)
        },
        setTempSubscriptionPackage({ commit }, payload) {
            commit('SET_TEMP_SUBSCRIPTION_PACKAGE', payload)
        },
        async fetchActiveSubscription({ commit }) {
            try {
                const response = await this.$api.get('api/users/bundle')
                if (response.status === 200 && response.data.data) {
                    commit('SET_ACTIVE_SUBSCRIPTION', response.data.data)
                } else {
                    commit('SET_ACTIVE_SUBSCRIPTION', {})
                }
                return response
            } catch (error) {
                console.error(error)
            }
        },
        async fetchSubscriptionBoundles({ commit }, payload) {
            const response = await this.$api.get('api/bundles')
            commit('SET_SUBSCRIPTION_BOUNDLES', response.data.data)
        },

        async fetchTrialDays({ commit }) {
            try {
                const response = await this.$api.get('api/trial-days')
                commit('SET_TRIAL_DAYS', response.data.data.trial_days)
            } catch (error) {
                throw Error(error)
            }
        },
        async submitPayment({ commit }, payload) {
            commit('CHANGE_PAYMENT_STATUS', 'sending')
            try {
                const paymentResponse = await this.$api.get(`api/payments/${payload}`)
                const { url, paymentId } = paymentResponse.data.data

                localforage.setItem(`${namespace}.subscriptionPaymentId`, paymentId)

                window.location.href = url

                commit('CHANGE_PAYMENT_STATUS', 'sent')
            } catch (err) {
                commit('CHANGE_PAYMENT_STATUS', 'error')
            }
        },
        async getPaymentStatus({ commit }, payload) {
            const paymentStatus = await this.$api.get(`api/payments/payment-status/${payload}`)
            commit('CHANGE_PAYMENT_STATUS', paymentStatus.data.data.status)
        }

    },
    getters: {
        trialDays: state => state.trialDays,
        boundles: state => state.boundles,
        paymentStatus: state => state.paymentStatus,
        tempSubscription: state => state.tempSubscription,
        tempSubscriptionPackage: state => state.tempSubscriptionPackage,
        activeSubscription: state => state.activeSubscription,
        userHasActiveSubscription: state => state.activeSubscription && state.activeSubscription.activeTo && dayjs().isSameOrBefore(dayjs(state.activeSubscription.activeTo), 'day')
    }
}
